import emptyImage from '../assets/img/emptyImage.png'

const Empty = () => {
    return (
      <div className="col-span-4">
        <img className="" src={emptyImage} alt="empty-image" />
        <div className="">No matches found.</div>
      </div>
    );
}

export default Empty;